import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const LifecycleUpdateEventDateDialog = ({
  dateConfirmOpen,
  closeDialogAction,
  pendingDate,
  updateDateAction,
  shouldShowInternalMessage = false,
}: {
  dateConfirmOpen: boolean;
  closeDialogAction: () => void;
  pendingDate: string | undefined;
  updateDateAction: () => void;
  shouldShowInternalMessage?: boolean;
}) => {
  return (
    <Dialog
      open={dateConfirmOpen}
      onClose={closeDialogAction}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <WarningAmberRoundedIcon sx={{ color: "warning.main" }} />
        Update Event Date
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Changing the event date{" "}
          {pendingDate ? (
            <>
              to <strong>{pendingDate}</strong>{" "}
            </>
          ) : (
            ""
          )}
          will update the event date for <strong>all products</strong> —
          including any product-level dates that have been individually edited.
        </DialogContentText>
        {shouldShowInternalMessage && (
          <DialogContentText sx={{ mt: 1 }}>
            This change is <strong>customer-facing</strong>: the updated date
            will be reflected for you and your customer.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialogAction} variant="outlined">
          Cancel
        </Button>
        <Button onClick={updateDateAction} variant="contained" color="primary">
          Update All Dates
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LifecycleUpdateEventDateDialog;
